export default __webpack_public_path__ + "static/media/logo-access.335d029d.svg";